module.exports = __webpack_public_path__ + "fonts/roboto-v27-latin-ext_latin-900.a8f7983.woff";